import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, map, publishReplay, refCount} from 'rxjs/operators';
import {ShellBannerDesc} from '../app-shell/shell-banners/shell-banner-desc';

@Injectable({
  providedIn: 'root',
})
export class ShellBannerService {
  static BANNER_ID_APP_INSTALL = 'appHomeScreenInstall';
  static BANNER_ID_WEBPUSH_SUBCRIBE = 'webpushNotificationSubcsribe';
  static BANNER_ID_INSURANCE_INFO_REQUEST = 'pendingInsuranceInfoRequest';
  static BANNER_ID_SIGNING_PACKAGE_PENDING = 'pendingSigningPackage';

  banners$ = new BehaviorSubject<ShellBannerDesc[]>([]);
  firstBanner$: Observable<ShellBannerDesc | null>;
  bannersVisible$ = new BehaviorSubject<boolean>(true);

  constructor() {
    this.firstBanner$ = this.banners$.pipe(
      map(b => b.length === 0 ? null : b[0]),
      distinctUntilChanged(),
      publishReplay(1), refCount(),
    );
  }

  addBanner(desc: ShellBannerDesc) {
    const curBanners = this.banners$.getValue();
    const filteredBanners = curBanners.filter(d => d.key !== desc.key);
    const newBanners = [...filteredBanners, desc];
    this.banners$.next(newBanners);
  }

  clearBanner(key: string) {
    const curBanners = this.banners$.getValue();
    const newBanners = curBanners.filter(d => d.key !== key);
    this.banners$.next(newBanners);
  }

  clearFirstBanner() {
    const curBanners = this.banners$.getValue();
    const newBanners = curBanners.length === 0 ? [] : curBanners.splice(1, curBanners.length);
    this.banners$.next(newBanners);
  }

  setBannersVisible(visible: boolean) {
    this.bannersVisible$.next(visible);
  }
}
